<template>
  <div>
    <CardComponent>
      <span class="title">Add Voucher Codes</span>
      <ValidationObserver ref="observer" v-slot="{ passes }">
        <form @submit.prevent="passes(submit)">
          <div class="columns is-multiline">
            <div class="column is-12">
              <div class="control">
                <BaseInput
                  v-model="item.codes"
                  type="textarea"
                  label="CODES (ONE PER LINE)"
                  rules="required"
                />
              </div>
            </div>
            <div class="column is-12">
              <b-button
                type="is-primary"
                @click.prevent="showGenerate = !showGenerate"
              >
                {{ showGenerate ? 'Hide' : 'Show' }} Generate Random
                Codes</b-button
              >
            </div>
            <template v-if="showGenerate">
              <div class="column is-4">
                <div class="control">
                  <BaseInput
                    v-model="noOfCodes"
                    type="number"
                    label="Number of Codes"
                    rules="required"
                  />
                </div>
              </div>
              <div class="column is-4">
                <div class="control">
                  <BaseInput
                    v-model="noOfChars"
                    type="number"
                    label="Number of Characters"
                    rules="required"
                  />
                </div>
              </div>
              <div class="column is-4">
                <div class="control has-padding-top-25">
                  <b-button
                    :disabled="loading"
                    type="is-primary"
                    size="is-medium"
                    @click="generateCodes(noOfCodes, noOfChars)"
                  >
                    Generate</b-button
                  >
                </div>
              </div>
            </template>
            <div class="column is-6">
              <div class="control">
                <BaseDateTimePicker
                  v-model="item.expirydate"
                  label="Expiry Date (OPTIONAL)"
                />
              </div>
            </div>
            <div class="column is-6">
              <div class="control">
                <BaseSelect
                  v-model="item.discounttype"
                  label="Discount Type"
                  :rules="``"
                >
                  <option value="">None</option>
                  <option value="Percentage">Percentage</option>
                  <option value="Amount">Amount</option>
                </BaseSelect>
              </div>
            </div>
            <div class="column is-6">
              <div class="control">
                <BaseInput
                  v-model="item.discountamount"
                  min="0"
                  :max="item.discounttype == 'Percentage' ? 100 : 10000"
                  type="number"
                  label="Discount Amount"
                  rules="required"
                />
              </div>
            </div>
          </div>
          <div class="has-text-centered">
            <div class="is-block has-margin-bottom-15">
              <b-button
                class="has-margin-right-10"
                size="is-medium"
                @click="$parent.close()"
              >
                Cancel</b-button
              >
              <b-button
                :disabled="loading"
                type="is-primary"
                size="is-medium"
                @click="passes(submit)"
              >
                Create</b-button
              >
            </div>
          </div>
        </form>
      </ValidationObserver>
    </CardComponent>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent'
import BaseDateTimePicker from '@/components/BaseDateTimePicker'
import BaseSelect from '@/components/BaseSelect'
import VoucherApi from '@/api/voucher'

export default {
  name: 'AddVoucherCodes',
  components: {
    CardComponent,
    BaseDateTimePicker,
    BaseSelect,
  },
  props: {
    event: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      initialized: false,
      loading: false,
      item: {
        codes: '',
      },
      showGenerate: false,
      noOfCodes: 10,
      noOfChars: 5,
    }
  },
  computed: {},
  async created() {},
  methods: {
    generateCode(length) {
      let text = ''
      const possible = 'abcdefghijklmnopqrstuvwxyz0123456789'

      for (var i = 0; i < length; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length))

      return text
    },
    generateCodes(number, length) {
      let codes = ''
      for (var i = 0; i < number; i++) {
        codes += this.generateCode(length) + '\r\n'
      }
      this.item.codes += codes
    },
    async submit() {
      this.loading = true
      this.item.event = this.event
      await VoucherApi.add(this.item)
      this.$buefy.toast.open({
        message: 'Added codes successfully!',
        position: 'is-top',
        type: 'is-success',
      })
      this.$emit('refresh')
      this.$parent.close()
    },
  },
}
</script>
